var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveAddItem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.425,
    y: 0.425,
    width: 13.15,
    height: 13.15,
    rx: 1.575,
    fill: "#004EFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.425,
    y: 0.425,
    width: 13.15,
    height: 13.15,
    rx: 1.575,
    stroke: "#004EFF",
    strokeWidth: 0.85
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49566 6.90162H7.35677V4.76273C7.35677 4.56585 7.19717 4.40625 7.00029 4.40625C6.80341 4.40625 6.64381 4.56585 6.64381 4.76273V6.90162H4.50492C4.30804 6.90162 4.14844 7.06122 4.14844 7.2581C4.14844 7.45498 4.30804 7.61458 4.50492 7.61458H6.64381V9.75347C6.64381 9.95035 6.80341 10.11 7.00029 10.11C7.19717 10.11 7.35677 9.95035 7.35677 9.75347V7.61458H9.49566C9.69254 7.61458 9.85214 7.45498 9.85214 7.2581C9.85214 7.06122 9.69254 6.90162 9.49566 6.90162Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveAddItem);
export default __webpack_public_path__ + "static/media/ActiveAddItem.6d6c0f357877bcc5469f68327a7b2c15.svg";
export { ForwardRef as ReactComponent };